import { gql } from '@apollo/client';

const ERRORS = `errors { path, message }`;

const FEE_TYPE_CORE_FIELDS = gql`
  fragment FeeTypeCoreFields on FeeType {
    id
    name
    customShortName
    special
    markup
  }
`;

export const FEE_TYPE_FIELDS = gql`
  ${FEE_TYPE_CORE_FIELDS}
  fragment FeeTypeFields on FeeType {
    ...FeeTypeCoreFields
    chargeAccount {
      id
      name
    }
    buyerChargeAccount {
      id
      name
    }
  }
`;

export const FEE_TYPE = gql`
  ${FEE_TYPE_FIELDS}
  query FeeType($id: ID!) {
    feeType(id: $id) {
      ...FeeTypeFields
    }
  }
`;

export const FEE_TYPES = gql`
  ${FEE_TYPE_FIELDS}
  query FeeTypes {
    feeTypes {
      ...FeeTypeFields
    }
  }
`;

const FEE_TYPE_ARGUMENTS = `
  $chargeAccountId: ID!
  $buyerChargeAccountId: ID
  $name: String!
  $customShortName: String
  $special: String
  $markup: Boolean
`;

const FEE_TYPE_VARIABLES = `
  chargeAccountId: $chargeAccountId
  buyerChargeAccountId: $buyerChargeAccountId
  name: $name
  customShortName: $customShortName
  special: $special
  markup: $markup
`;

export const CREATE_FEE_TYPE = gql`
  ${FEE_TYPE_CORE_FIELDS}
  mutation CreateFeeType (
    ${FEE_TYPE_ARGUMENTS}
  ) {
    createFeeType (
      ${FEE_TYPE_VARIABLES}
    ) {
      feeType {
        ...FeeTypeCoreFields
      }
      ${ERRORS}
    }
  }
`;

export const UPDATE_FEE_TYPE = gql`
  ${FEE_TYPE_CORE_FIELDS}
  mutation UpdateFeeType (
    $id: ID!
    ${FEE_TYPE_ARGUMENTS}
  ) {
    updateFeeType (
      id: $id
      ${FEE_TYPE_VARIABLES}
    ) {
      feeType {
        ...FeeTypeCoreFields
      }
      ${ERRORS}
    }
  }
`;

export const HIDE_FEE_TYPE = gql`
  ${FEE_TYPE_CORE_FIELDS}
  mutation HideFeeType ($id: ID!) {
    hideFeeType (id: $id) {
      feeType {
        ...FeeTypeCoreFields
      }
      ${ERRORS}
    }
  }
`;

export const UNHIDE_FEE_TYPE = gql`
  ${FEE_TYPE_CORE_FIELDS}
  mutation UnhideFeeType ($id: ID!) {
    unhideFeeType (id: $id) {
      feeType {
        ...FeeTypeCoreFields
      }
      ${ERRORS}
    }
  }
`;
